var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-wrap"},[_c('van-nav-bar',{staticClass:"navbar",attrs:{"title":_vm.headerTitle,"placeholder":false,"safe-area-inset-top":true,"fixed":"","border":false,"left-arrow":true},on:{"click-left":_vm.goBack}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }